import Vue from 'vue'
import config from '@/config'
import Store from '@/store'
import '../packages/message'

// 错误提示
const $error = Vue.prototype.$error

// 错误状态码提示
const requestStatus = {
  '403': '访问或操作未获得授权，请联系管理员',
  '404': '找不到您请求的服务，请更正后重试',
  '500': '服务器连接失败，请稍后重试'
}

/**
 * 链接参数对象转换为字符串
 * @param {*} obj 参数
 * @returns {String}
 */
export function stringifyQuery(obj) {
  const encode = encodeURIComponent
  const res = obj
    ? Object.keys(obj)
        .map(key => {
          const val = obj[key]

          if (val === undefined) {
            return ''
          }

          if (val === null) {
            return encode(key)
          }

          if (Array.isArray(val)) {
            const result = []
            val.forEach(val2 => {
              if (val2 === undefined) {
                return
              }
              if (val2 === null) {
                result.push(encode(key))
              } else {
                result.push(encode(key) + '=' + encode(val2))
              }
            })
            return result.join('&')
          }

          return encode(key) + '=' + encode(val)
        })
        .filter(x => x.length > 0)
        .join('&')
    : null

  return res || ''
}

/**
 * ajax 服务数据处理
 * @param {Promise} ajax ajax 请求 Promise
 * @returns {Promise} 请求 Promise
 * @returns {config}  扩展接口
 */
export default async function handleAjax(ajax, config = {}) {
  const { source = 'data' } = config
  return ajax
    .then(
      ({ data: resData }) => {
        if (!resData) throw new Error('服务未返回数据')

        let { data, success, message, tasks } = resData

        // 文件下载
        /* if (window.Blob && resData instanceof window.Blob) {
          return resData
        } else  */ if (
          success === true
        ) {
          if (source === 'tasks') {
            return tasks
          }
          return data
        } else {
          throw new Error(message)
        }
      },
      err => {
        let msg
        let { status, statusText, data } = err.response || {}

        if ([303, 401, 511].includes(status)) {
          // 重定向或需要重新登录
        } else {
          // 根据状态码提示错误信息
          msg = requestStatus[status] || (status ? status + ': ' : '') + (statusText || err.message)
        }
        throw new Error(msg)
      }
    )
    .catch(err => {
      let msg = err.message
      msg && $error(msg)
      err.name = 'Ajax Error'
      throw err
    })
}

// 未处理的 Promise reject 不打印输出
window.addEventListener('unhandledrejection', function(event) {
  if (process.env.NODE_ENV !== 'production' || (localStorage && localStorage.getItem('fdd-debug') === 'true')) {
    // 开发环境暴露错误
  } else {
    event && event.preventDefault()
  }
})

// 清除本地 session 缓存 api
export function cleanCacheApi() {
  Object.keys(sessionStorage)
    .filter(key => !key.indexOf('api:'))
    .forEach(key => sessionStorage.removeItem(key))
}

// 下载
export function download(api, params) {
  let url = config.baseURL + api

  if (params) {
    const query = stringifyQuery(params)

    if (api.indexOf('?') === -1) url += '?authToken=' + sessionStorage.getItem('authToken') + '&' // ioo 加authToken

    url += query
  }

  window.open(url)
}

// 解析用户角色对应的服务地址，控制台添加 control
export function parseCtrlUrl(url) {
  return Store.state.isUserPage
    ? url
    : /^\/ecoSystem\/api\/v1\//.test(url)
    ? url.replace('/ecoSystem/api/v1/', '/ecoSystem/api/v1/control/')
    : url.replace('/ecoSystem', '/ecoSystem/control')
}

// 首次进入清理缓存服务
cleanCacheApi()
